import { useCallback, useRef } from "react";
import { type Observable, type Subscription } from "rxjs";

interface SearchSubscriptionHandlers<TResult> {
  onBegin: () => void;
  onError: () => void;
  onNext: (data: TResult) => void;
  onComplete: () => void;
}

export function useSearchSubscription<TData, TResult>(
  getResults: (data: TData) => Observable<TResult>,
  handlers: SearchSubscriptionHandlers<TResult>,
) {
  const subscriptionRef = useRef<Subscription | null>(null);

  const search = useCallback(
    (data: TData) => {
      subscriptionRef.current?.unsubscribe();
      handlers.onBegin();
      subscriptionRef.current = getResults(data).subscribe({
        error: handlers.onError,
        next: handlers.onNext,
        complete: handlers.onComplete,
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return search;
}
